module.exports = require('./helpers/bundle-url').getBundleURL('fqZHd') + "logo-dark.eefe0b7f.svg";